const ro = {
  pleaseEnterUsername: "Vă rugăm să introduceți un nume de utilizator",
  cannotFriendYourself: "Nu vă puteți trimite o cerere de prietenie propriei persoane.",
  friendRequestSent: "Cererea de prietenie a fost trimisă!",
  failedToSendRequest: "Trimiterea cererii a eșuat",
  linkCopied: "Linkul a fost copiat în clipboard!",
  backToInvites: "Înapoi la invitații",
  sendFriendRequestByUsername: "Trimite cerere de prietenie după numele de utilizator",
  enterUsername: "Introduceți numele de utilizator",
  send: "Trimite",
  yourInviteQrCode: "Codul tău QR de invitație",
  inviteLink: "Link de invitație",
  scanQrOrUseLink: "Scanează acest cod QR sau folosește acest link pentru a trimite o cerere de prietenie",
  copyInviteLink: "Copiază linkul de invitație",
  goToItem: "Mergi la element",
  verificationEmailSent: "E-mailul de verificare a fost trimis! Verifică-ți căsuța de e-mail.",
  verificationEmailFailed: "Trimiterea e-mailului de verificare a eșuat. Încearcă din nou.",
  verifyYourEmail: "Verifică-ți adresa de e-mail",
  verifyEmailInstructions: "Te rugăm să îți verifici adresa de e-mail pentru a accesa contul. Verifică-ți căsuța de e-mail pentru linkul de verificare.",
  sending: "Se trimite...",
  resendVerificationEmail: "Retrimite e-mailul de verificare",
  login: "Autentificare",
  register: "Înregistrare",
  home: "Acasă",
  calendar: "Calendar",
  friends: "Prieteni",
  profile: "Profil",
  logout: "Deconectare",
  loading: "Se încarcă...",
  language: "Limbă",
  calendarSelectPlaceSuggestion: "Te rugăm să selectezi un loc din sugestii pentru a atașa coordonatele.",
  calendarSelectDateAndTime: "Te rugăm să selectezi data și ora.",
  calendarPositiveDuration: "Te rugăm să introduci o durată pozitivă.",
  calendarFutureDateRequired: "Data și ora evenimentului trebuie să fie în viitor.",
  calendarCreateEventFailed: "Crearea evenimentului a eșuat. Încearcă din nou.",
  cancel: "Anulează",
  createNewEvent: "Creează un eveniment nou",
  week: "Săptămână",
  month: "Lună",
  eventTitle: "Titlu",
  date: "Dată",
  time: "Oră",
  duration: "Durată",
  endsAt: "Se termină la",
  place: "Loc",
  searchForPlace: "Caută un loc",
  placeSearchTip: "Sfat: începe să tastezi și selectează un rezultat pentru a atașa coordonatele.",
  description: "Descriere",
  createEvent: "Creează eveniment",
  today: "Astăzi",
  previousMonth: "Luna anterioară",
  nextMonth: "Luna următoare",
  previous: "Anterior",
  next: "Următor",
  mondayShort: "Lun",
  tuesdayShort: "Mar",
  wednesdayShort: "Mie",
  thursdayShort: "Joi",
  fridayShort: "Vin",
  saturdayShort: "Sâm",
  sundayShort: "Dum",
  more: "mai mult",
  mustRespondWillBeforeReposting: "Trebuie să răspunzi „Voi participa” înainte de a redistribui",
  event: "Eveniment",
  backToCalendar: "Înapoi la calendar",
  addToGoogleCalendar: "Adaugă în Google Calendar",
  when: "Când",
  where: "Unde",
  openLocationInGoogleMaps: "Deschide locația în Google Maps",
  hosts: "Organizatori",
  yourResponse: "Răspunsul tău",
  currentResponse: "Răspuns curent",
  response_will: "Voi participa",
  response_might: "S-ar putea să particip",
  response_wont: "Nu voi participa",
  willRunIntoYou: "Voi trece pe acolo",
  mightDropBy: "S-ar putea să trec pe acolo",
  wontCome: "Nu voi veni",
  repostToMyFriends: "Redistribuie prietenilor mei",
  responses: "Răspunsuri",
  willAttend: "Va participa",
  reposted: "Redistribuit",
  mightAttend: "S-ar putea să participe",
  cancelEvent: "Anulează evenimentul",
  cancellationEmailNoticeBefore: "Persoanele care și-au confirmat participarea",
  cancellationEmailNoticeAfter: "vor primi un e-mail de notificare privind anularea.",
  optionalCancellationMessage: "Mesaj opțional pentru participanți (maxim 1000 de caractere)",
  confirmCancelEvent: "Confirmă anularea evenimentului",
  clear: "Șterge",
  confirmCancellation: "Confirmă anularea",
  confirmCancellationMessage: "Sigur dorești să anulezi acest eveniment? Acest lucru va notifica participanții confirmați și va elimina evenimentul.",
  eventCancelledNotified: "Eveniment anulat. Notificați",
  attendees: "participanți",
  failedToCancelEvent: "Anularea evenimentului a eșuat",
  back: "Înapoi",
  cancelled: "Anulat",
  ok: "OK",
  forgotPassword: "Ai uitat parola",
  email: "E-mail",
  passwordResetLinkSent: "Dacă există un cont, a fost trimis un link pentru resetarea parolei.",
  passwordResetRequestFailed: "Solicitarea resetării parolei a eșuat.",
  sendResetLink: "Trimite link de resetare",
  addFriend: "Adaugă prieten",
  incomingRequests: "Cereri primite",
  accept: "Acceptă",
  deny: "Respinge",
  myFriends: "Prietenii mei",
  noFriendsYet: "Încă nu ai prieteni. Începe să adaugi câțiva!",
  seeProfile: "Vezi profilul",
  noEventsToRespondTo: "Nu există evenimente la care să răspunzi",
  allCaughtUp: "Ești la zi. Revino mai târziu pentru a vedea evenimente noi de la prietenii tăi.",
  events: "Evenimente",
  unknown: "Necunoscut",
  noDescriptionProvided: "Nu a fost furnizată nicio descriere.",
  will: "Da",
  maybe: "Poate",
  wont: "Nu",
  userNotFound: "Utilizator negăsit",
  friendRequestSentSuccessfully: "Cererea de prietenie a fost trimisă cu succes!",
  friendInvitation: "Invitație de prietenie",
  sendFriendRequest: "Trimite cerere de prietenie",
  loginToSendFriendRequest: "Autentifică-te pentru a trimite o cerere de prietenie",
  chooseLanguage: "Alege limba",
  invalidCredentials: "Date de autentificare invalide. Încearcă din nou.",
  username: "Nume de utilizator",
  password: "Parolă",
  forgotPasswordQuestion: "Ai uitat parola?",
  dontHaveAccount: "Nu ai cont?",
  registerHere: "Înregistrează-te aici",
  invalidProfilePhotoType: "Tip de fișier invalid. Încarcă o imagine JPEG, PNG, GIF sau WebP.",
  invalidFileExtension: "Extensie de fișier invalidă",
  allowedExtensions: "Permise",
  fileTooLarge: "Fișier prea mare",
  maximumFileSize: "Maxim",
  profilePhotoRemoved: "Fotografia de profil a fost eliminată.",
  failedToRemoveProfilePhoto: "Eliminarea fotografiei de profil a eșuat",
  profileUpdatedSuccessfully: "Profilul a fost actualizat cu succes!",
  failedToUpdateProfile: "Actualizarea profilului a eșuat",
  privateEmailExplanation: "Doar tu îți poți vedea adresa de e-mail pentru a evita mesajele nesolicitate în afara platformei",
  yourEmailIsPrivate: "Adresa ta de e-mail este privată.",
  profilePhoto: "Fotografie de profil",
  removePhoto: "Elimină fotografia",
  firstName: "Prenume",
  lastName: "Nume",
  tellPeopleAboutYourself: "Spune-le oamenilor despre tine",
  whereToContactMe: "Cum mă poți contacta",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Salvează",
  notSet: "Nesetat",
  editProfile: "Editează profilul",
  imageToCrop: "Imagine de decupat",
  zoom: "Zoom",
  usePhoto: "Folosește fotografia",
  name: "Nume",
  whereToContact: "Date de contact",
  removeFriendship: "Elimină prietenia",
  confirmRemoveFriend: "Confirmă eliminarea prietenului",
  confirmRemoveFriendBefore: "Sigur dorești să elimini",
  confirmRemoveFriendAfter: "din lista ta de prieteni?",
  friendRemoved: "Prieten eliminat.",
  failedToRemoveFriend: "Eliminarea prietenului a eșuat.",
  confirmRemove: "Confirmă eliminarea",
  error: "Eroare",
  removed: "Eliminat",
  passwordsDoNotMatch: "Parolele nu coincid",
  registrationFailed: "Înregistrarea a eșuat. Încearcă din nou.",
  confirmPassword: "Confirmă parola",
  alreadyHaveAccount: "Ai deja un cont?",
  loginHere: "Autentifică-te aici",
  passwordResetSuccessfully: "Parola a fost resetată cu succes.",
  failedToResetPassword: "Resetarea parolei a eșuat.",
  resetPassword: "Resetează parola",
  newPassword: "Parolă nouă",
  confirmNewPassword: "Confirmă noua parolă",
  setNewPassword: "Setează noua parolă",
  emailVerifiedSuccessfully: "Adresa de e-mail a fost verificată cu succes!",
  emailVerificationFailed: "Verificarea a eșuat. Linkul poate fi invalid sau expirat.",
  verifying: "Se verifică...",
  verified: "Verificat!",
  redirectingToHome: "Redirecționare către pagina principală...",
  verificationFailed: "Verificare eșuată",
  goToHome: "Mergi la pagina principală",
  about: "Despre",
  aboutConceptTitle: "Concept",
  aboutCreatorIntroduction: "Salut, sunt Crypt0, cățărător și creatorul Run Into Me.",
  aboutCreatorStory: "Am creat site-ul deoarece sunt sociabil și petreceam prea mult timp organizând sesiuni de cățărare cu alții.",
  aboutPlanningProblem: "Voiam să anunț pe toată lumea simultan când și unde voi merge la cățărat, fără invitație formală.",
  aboutDeveloperSolution: "Atunci mi-am amintit că sunt dezvoltator și puteam crea singur soluția.",
  aboutWelcome: "Bun venit la Run Into Me, unde îți anunți prietenii despre activități la care se pot alătura fără presiune.",
  aboutCallToAction: "Publică aici următoarea activitate care este mai distractivă împreună!",
  aboutTutorialTitle: "Tutorial",
  aboutCalendarCreateEvent: "În ecranul Calendar poți crea și un eveniment nou.",
  aboutEventColorsIntroduction: "Culorile indică starea participării:",
  aboutColorGold: "Auriu",
  aboutColorGoldDescription: "Organizezi acest eveniment.",
  aboutColorGreen: "Verde",
  aboutColorGreenDescription: "Participi la eveniment.",
  aboutColorOrange: "Portocaliu",
  aboutColorOrangeDescription: "Ai răspuns „poate”.",
  aboutColorBlue: "Albastru",
  aboutColorBlueDescription: "Nu ai răspuns încă.",
  aboutColorGray: "Gri",
  aboutColorGrayDescription: "Ai refuzat invitația.",
  aboutCalendarEventDetails: "Selectează un eveniment pentru detalii și răspuns.",
  aboutFriendPageTitle: "Pagina Prieteni",
  aboutFriendPageDescription: "Introdu numele de utilizator sau trimite linkul / codul QR.",
  aboutHomePageTitle: "Pagina principală",
  aboutHomePageDescription: "Vezi evenimentele viitoare și indică dacă participi.",
  aboutRepostScreenTitle: "Ecranul de redistribuire",
  aboutGoogleCalendarDescription: "Adaugă evenimentul în Google Calendar cu acest buton.",
  aboutRepostDescription: "După confirmare poți redistribui evenimentul prietenilor.",
};

export default ro;